module.exports = __webpack_public_path__ + "assets/images/10HBox.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10HBox.png
// module id = 1281
// module chunks = 1